<div class="stepper-container">
    @for (step of steps; track step; let i = $index) {

        <div class="step-wrapper" [attr.data-id]="step.label">
            <div class="circle" [ngClass]="step.state">
                <i [class]="getIconClass(step.iconKey, step.state)" aria-hidden="true"></i>
            </div>
            <div class="label" [ngClass]="step.state">{{ step.label }}</div>

            @if (i < steps.length - 1) {
<div class="connector-line" [ngClass]="{ 'active': isLineActive(i) }"></div>
}
        </div>
    
}
</div>